export default __webpack_public_path__ + "static/media/2fa.a63468aa.jpg";